module.exports = __webpack_public_path__ + "assets/burger-menu-429eea.svg";